import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PageStyles.css';

const SemiPage = () => {
  const [activeFinancialGain, setActiveFinancialGain] = useState(0);

  const financialGains = [
    {
      title: "Économies significatives",
      description: "En remplaçant un employé par notre solution, vous réalisez des économies substantielles sur vos coûts opérationnels. Ces économies peuvent être réinvesties dans votre business, vos équipements ou vos formations."
    },
    {
      title: "Retour sur investissement rapide", 
      description: "Notre solution se rentabilise rapidement grâce aux économies réalisées sur les coûts de personnel. Un investissement intelligent qui améliore votre rentabilité."
    },
    {
      title: "Zéro coût caché",
      description: "Avec un employé : charges sociales, congés payés, arrêts maladie, formations, matériel de bureau, assurance. Avec notre IA : un prix fixe mensuel, sans surprise, sans coût caché."
    },
    {
      title: "Croissance sans limite",
      description: "Un employé a ses limites : il ne peut gérer qu'un certain nombre de clients. Notre IA s'adapte à votre croissance sans coût supplémentaire. Vous pouvez doubler votre activité sans doubler vos coûts."
    }
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Header */}
        <div className="page-header">
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem'}}>
            <Link to="/" style={{fontSize: '1.5rem', fontWeight: '700', color: '#60a5fa', textDecoration: 'none'}}>
              Monagora
            </Link>
            <Link to="/" style={{color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem'}}>
              ← Retour à l'accueil
            </Link>
          </div>
          
          <div style={{textAlign: 'center', marginBottom: '1rem'}}>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'rgba(167, 139, 250, 0.1)',
              color: '#a78bfa',
              padding: '0.5rem 1rem',
              borderRadius: '50px',
              fontSize: '0.9rem',
              fontWeight: '600',
              border: '1px solid rgba(167, 139, 250, 0.3)'
            }}>
              Gains Financiers
            </span>
          </div>
          
          <h1 className="page-title">
            Votre Argent Récupéré
          </h1>
          <p className="page-subtitle">
            Découvrez comment notre solution vous permet de réaliser des économies 
            significatives sur vos coûts opérationnels.
          </p>
        </div>

        {/* Section principale avec calculatrice financière */}
        <div className="page-section">
          <h2 className="section-title">Comparaison des Coûts</h2>
          
          <div className="section-content">
            <div className="content-text">
              <h3 style={{color: '#a78bfa', fontSize: '1.8rem', marginBottom: '2rem'}}>
                Analyse Financière
              </h3>
              
              <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#a78bfa',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Salaire employé : 2500€/mois</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#a78bfa',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Charges sociales : +50%</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#a78bfa',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Congés payés : 5 semaines/an</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#a78bfa',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Arrêts maladie : 15 jours/an</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#a78bfa',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Formations : 2000€/an</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#a78bfa',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Matériel bureau : 1000€/an</span>
                </div>
              </div>
            </div>
            
            <div className="content-visual">
              <div className="financial-calculator">
                <div className="calculator-header">
                  <div className="calculator-title">Comparaison des Coûts</div>
                  <div className="calculator-subtitle">Analyse annuelle</div>
                </div>
                
                <div className="calculator-comparison">
                  <div className="comparison-column">
                    <div className="comparison-title">Avec un Employé</div>
                    <div className="cost-breakdown">
                      <div className="cost-item">
                        <span className="cost-label">Salaire</span>
                        <span className="cost-value">30 000€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Charges sociales</span>
                        <span className="cost-value">15 000€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Congés payés</span>
                        <span className="cost-value">3 000€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Formations</span>
                        <span className="cost-value">2 000€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Matériel</span>
                        <span className="cost-value">1 000€</span>
                      </div>
                      <div className="cost-total">
                        <span className="cost-label">TOTAL</span>
                        <span className="cost-value">51 000€</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="comparison-column">
                    <div className="comparison-title">Avec Monagora</div>
                    <div className="cost-breakdown">
                      <div className="cost-item">
                        <span className="cost-label">Abonnement</span>
                        <span className="cost-value">3 588€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Charges</span>
                        <span className="cost-value">0€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Congés</span>
                        <span className="cost-value">0€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Formations</span>
                        <span className="cost-value">0€</span>
                      </div>
                      <div className="cost-item">
                        <span className="cost-label">Matériel</span>
                        <span className="cost-value">0€</span>
                      </div>
                      <div className="cost-total">
                        <span className="cost-label">TOTAL</span>
                        <span className="cost-value">3 588€</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="savings-result">
                  <div className="savings-highlight">
                    <span className="savings-amount">Économies importantes</span>
                    <span className="savings-label">sur vos coûts annuels</span>
                  </div>
                  <div className="roi-highlight">
                    <span className="roi-percentage">ROI rapide</span>
                    <span className="roi-label">grâce aux économies réalisées</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section gains financiers détaillés */}
        <div className="page-section">
          <h2 className="section-title">Comment Vous Gagnez de l'Argent</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '4rem', alignItems: 'flex-start'}}>
            {/* Colonne de gauche - Titres courts */}
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
              {financialGains.map((gain, index) => (
                <div
                  key={index}
                  style={{
                    padding: '1.5rem 2rem',
                    background: activeFinancialGain === index 
                      ? 'rgba(167, 139, 250, 0.15)' 
                      : 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(15px)',
                    borderRadius: '12px',
                    border: activeFinancialGain === index 
                      ? '2px solid rgba(167, 139, 250, 0.3)' 
                      : '1px solid rgba(255, 255, 255, 0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={() => setActiveFinancialGain(index)}
                >
                  {/* Indicateur visuel à gauche */}
                  <div style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: activeFinancialGain === index ? '4px' : '0px',
                    background: 'linear-gradient(135deg, #a78bfa, #7c3aed)',
                    transition: 'width 0.3s ease'
                  }}></div>
                  
                  <h3 style={{
                    color: activeFinancialGain === index ? '#a78bfa' : '#f1f5f9',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    margin: 0,
                    transition: 'color 0.3s ease',
                    transform: activeFinancialGain === index ? 'scale(1.02)' : 'scale(1)',
                    transformOrigin: 'left center'
                  }}>
                    {gain.title}
                  </h3>
                </div>
              ))}
            </div>
            
            {/* Colonne de droite - Détails */}
            <div style={{
              padding: '3rem',
              background: 'rgba(255, 255, 255, 0.08)',
              backdropFilter: 'blur(20px)',
              borderRadius: '20px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              minHeight: '300px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '3px',
                background: 'linear-gradient(135deg, #a78bfa, #7c3aed)',
                opacity: 0.8
              }}></div>
              
              <h3 style={{
                color: '#a78bfa',
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '1.5rem',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
              }}>
                {financialGains[activeFinancialGain].title}
              </h3>
              
              <p style={{
                color: '#e2e8f0',
                fontSize: '1.1rem',
                lineHeight: '1.7',
                margin: 0,
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
              }}>
                {financialGains[activeFinancialGain].description}
              </p>
            </div>
          </div>
        </div>

        {/* Section métriques financières */}
        <div className="page-section">
          <h2 className="mode-page-hero-main-title-heading">Avantages Financiers</h2>
          
          <div className="metrics-grid">
            <div className="metric-item">
              <span className="metric-number">Coût fixe</span>
              <span className="metric-label">Prix prévisible</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">Zéro charge</span>
              <span className="metric-label">Pas de charges sociales</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">Disponible 24h/24</span>
              <span className="metric-label">Pas de congés</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">Scalable</span>
              <span className="metric-label">Croissance sans limite</span>
            </div>
          </div>
        </div>

        {/* Section ce que vous pouvez faire avec ces économies */}
        <div className="page-section">
          <h2 className="mode-page-hero-main-title-heading">Ce Que Vous Pouvez Faire Avec Vos Économies</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem', marginTop: '2rem'}}>
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                🚀
              </div>
              <h3>Développer Votre Business</h3>
              <p>
                Investir dans le marketing, l'équipement ou l'expansion de votre activité
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #f59e0b, #d97706)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                📈
              </div>
              <h3>Augmenter Vos Bénéfices</h3>
              <p>
                Améliorer votre marge bénéficiaire grâce aux économies réalisées
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                🎯
              </div>
              <h3>Recruter un Vendeur</h3>
              <p>
                Employer un commercial pour développer vos ventes
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #ef4444, #dc2626)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                💰
              </div>
              <h3>Épargner</h3>
              <p>
                Constituer une épargne de sécurité ou investir
              </p>
            </div>
          </div>
        </div>

        {/* Section timeline de rentabilisation */}
        <div className="page-section">
          <h2 className="mode-page-hero-main-title-heading">Votre Rentabilisation Progressive</h2>
          
          <div style={{display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '2rem'}}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '2rem',
              padding: '2rem',
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #10b981, #059669)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '1.2rem'
              }}>
                1
              </div>
              <div>
                <h3 style={{color: '#10b981', marginBottom: '0.5rem'}}>Mois 1</h3>
                <p style={{color: '#e2e8f0', margin: 0}}>Vous commencez à réaliser des économies dès le premier mois</p>
              </div>
            </div>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '2rem',
              padding: '2rem',
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '1.2rem'
              }}>
                6
              </div>
              <div>
                <h3 style={{color: '#f59e0b', marginBottom: '0.5rem'}}>Mois 6</h3>
                <p style={{color: '#e2e8f0', margin: 0}}>Les économies cumulées deviennent significatives</p>
              </div>
            </div>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '2rem',
              padding: '2rem',
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '1.2rem'
              }}>
                12
              </div>
              <div>
                <h3 style={{color: '#8b5cf6', marginBottom: '0.5rem'}}>Mois 12</h3>
                <p style={{color: '#e2e8f0', margin: 0}}>Votre investissement est largement rentabilisé !</p>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation vers autres pages */}
        <div className="page-section" style={{borderBottom: 'none'}}>
          <h2 className="mode-page-hero-main-title-heading">Découvrez Nos Autres Avantages</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '2rem'}}>
            <Link to="/automatique" style={{textDecoration: 'none'}}>
              <div className="feature-card" style={{cursor: 'pointer', transition: 'all 0.3s ease'}}>
                <div className="feature-icon" style={{background: 'linear-gradient(135deg, #60a5fa, #3b82f6)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: 'white', marginBottom: '1.5rem'}}>
                  ⏰
                </div>
                <h3 style={{color: '#60a5fa'}}>Temps Récupéré</h3>
                <p>
                  Découvrez comment l'automatisation vous fait gagner du temps
                </p>
                <div style={{marginTop: '1rem', color: '#60a5fa', fontWeight: '600'}}>
                  Découvrir →
                </div>
              </div>
            </Link>
            
            <Link to="/ia-vs-humain" style={{textDecoration: 'none'}}>
              <div className="feature-card" style={{cursor: 'pointer', transition: 'all 0.3s ease'}}>
                <div className="feature-icon" style={{background: 'linear-gradient(135deg, #a78bfa, #7c3aed)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: 'white', marginBottom: '1.5rem'}}>
                  🤖
                </div>
                <h3 style={{color: '#a78bfa'}}>IA vs Humain</h3>
                <p>
                  Découvrez pourquoi notre IA surpasse un employé humain
                </p>
                <div style={{marginTop: '1rem', color: '#a78bfa', fontWeight: '600'}}>
                  Découvrir →
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SemiPage; 